export default {
  root: {
    marginTop: 50,
    marginBottom: 50,
    display: 'flex',
    alignItems: 'center',
    '& label': {
      margin: 0,
    },
  },
  error: {
    color: '#f44336',
    fontSize: '.75rem',
    padding: '0 25px',
  },
  title: {
    marginBottom: '24px !important',
  },
  section: {
    color: '#637381',
  },
  button: {
    textTransform: 'none !important',
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '10px !important',
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
  },
};
